import { createSlice } from "@reduxjs/toolkit";

export const convenienceFeesAndChargesSlice = createSlice({
    name: "convenienceFeesAndCharges",
    initialState: {
        feesAndCharges: [],
        loading: false,
        error: null,
        edit_fee_id: null,
        editingFee: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setFeesAndCharges: (state, action) => {
            state.feesAndCharges = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setEditingFeeId: (state, action) => {
            state.edit_fee_id = action.payload;
        },
        setEditingFee: (state, action) => {
            const feeToEdit = state.feesAndCharges.find((fee) => fee.id === action.payload);
            if (feeToEdit) state.editingFee = feeToEdit;
        },
        addFeeOrCharge: (state, action) => {
            state.feesAndCharges.push(action.payload);
        },
        updateFeeOrCharge: (state, action) => {
            const index = state.feesAndCharges.findIndex((fee) => fee.id === action.payload.id);
            if (index !== -1) {
                state.feesAndCharges[index] = action.payload;
            }
        },
    },
});

export const {
    setLoading,
    setFeesAndCharges,
    setError,
    setEditingFeeId,
    setEditingFee,
    addFeeOrCharge,
    updateFeeOrCharge,
} = convenienceFeesAndChargesSlice.actions;

export default convenienceFeesAndChargesSlice.reducer;
